// The languages Decode My Student targets. `enabled` means a full UI translation
// catalog exists and the language is selectable now; the rest are the agreed
// roadmap (Top 10) and appear in the picker as "coming soon" until their catalog
// lands. The AI response layer (see i18n/index.tsx → aiLanguageDirective) already
// supports every language here, because the model is natively multilingual — so
// turning one on is just adding its catalog file, not new plumbing.
//
// `dir` drives layout direction: Arabic is right-to-left and flips the whole UI.

export type LangCode =
  | 'en' | 'es' | 'fr' | 'pt' | 'de' | 'it' | 'ar' | 'zh' | 'hi' | 'ja' | 'ko';

export interface LanguageMeta {
  code: LangCode;
  native: string;   // the language's own name, shown in the picker
  english: string;  // English name, for our own reference / prompts
  flag: string;     // representative flag emoji (not a country claim — a visual cue)
  dir: 'ltr' | 'rtl';
  enabled: boolean; // true once a full UI catalog exists
}

export const LANGUAGES: LanguageMeta[] = [
  { code: 'en', native: 'English',   english: 'English',              flag: '🇺🇸', dir: 'ltr', enabled: true },
  { code: 'es', native: 'Español',   english: 'Spanish',              flag: '🇪🇸', dir: 'ltr', enabled: true },
  { code: 'fr', native: 'Français',  english: 'French',               flag: '🇫🇷', dir: 'ltr', enabled: false },
  { code: 'pt', native: 'Português', english: 'Portuguese',           flag: '🇧🇷', dir: 'ltr', enabled: false },
  { code: 'de', native: 'Deutsch',   english: 'German',               flag: '🇩🇪', dir: 'ltr', enabled: false },
  { code: 'it', native: 'Italiano',  english: 'Italian',              flag: '🇮🇹', dir: 'ltr', enabled: false },
  { code: 'ar', native: 'العربية',   english: 'Arabic',               flag: '🇸🇦', dir: 'rtl', enabled: false },
  { code: 'zh', native: '中文',       english: 'Chinese (Simplified)', flag: '🇨🇳', dir: 'ltr', enabled: false },
  { code: 'hi', native: 'हिन्दी',      english: 'Hindi',                flag: '🇮🇳', dir: 'ltr', enabled: false },
  { code: 'ja', native: '日本語',      english: 'Japanese',             flag: '🇯🇵', dir: 'ltr', enabled: false },
  { code: 'ko', native: '한국어',      english: 'Korean',               flag: '🇰🇷', dir: 'ltr', enabled: false },
];

export const LANG_BY_CODE: Record<LangCode, LanguageMeta> = LANGUAGES.reduce(
  (acc, l) => { acc[l.code] = l; return acc; },
  {} as Record<LangCode, LanguageMeta>
);
